import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import keyHeaders from './keyHeaders'

/**
 * Expected payload for POST /study/reviewer endpoint
 */
export interface IPasswordReset {
  email: string
}

interface IPasswordResetResponseBody extends IPasswordReset {
  email: string
}

/**
 * Expected response for POST /study/reviewer/password endpoint
 */
export interface IPasswordResetResponse extends AxiosResponse {
  data: IPasswordResetResponseBody
}

export function resetPassword(data: IPasswordReset, query?: string): Promise<IPasswordResetResponse> {
  const url = (() => {
    if (!query) return '/study/reviewer/password'
    return `/study/reviewer/password?${query}`
  })()
  return Client.post(url, data, { ...keyHeaders(), validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/resetPassword.ts